import BlStepperLongMv from './BlStepperLongMv.vue'

BlStepperLongMv.install = function(Vue) {
  Vue.component(BlStepperLongMv.name, BlStepperLongMv)
}

export default BlStepperLongMv
